<!--<template src="./wepass.html"></template>-->

<template>
	<div style="height: 100vh; display: flex; flex-direction: column">
		<HeaderContainer :text-name="user.name+'!'" :text-title="textTitle"/>
		<QRContainer/>
		<PassReservationContainer/>
		<InvalidReservationModal/>
		<EventWelcomeOverlay/>
		<FooterWelcom/>

		<!-- Event Confirmation Toast -->
		<div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 9999;">
			<div id="eventConfirmationToast" class="toast align-items-center text-white bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
				<div class="d-flex">
					<div class="toast-header bg-transparent text-white border-0">
						<i class="fas fa-check-circle me-2"></i>
						<strong class="me-auto">¡Confirmación exitosa!</strong>
						<button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>
					</div>
				</div>
				<div class="toast-body">
					Tu asistencia al evento ha sido confirmada correctamente.
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import * as bootstrap from 'bootstrap';
import {mapGetters, mapState} from 'vuex';

import {WebSocketClient} from "@/service/webSocketClient";

import FooterWelcom from "@/components/core/FooterWelcom";
import PassReservationContainer from "@/components/passReservationContainer/PassReservationContainer";
import HeaderContainer from "@/components/core/HeaderContainer.vue";
import InvalidReservationModal from "@/components/mods/invalidReservationModal/InvalidReservationModal";
import QRContainer from "@/components/core/QRContainer";
import EventWelcomeOverlay from "@/components/eventWelcome/EventWelcomeOverlay.vue";

export default {
	name: 'WePass',
	components: {
		QRContainer,
		HeaderContainer,
		PassReservationContainer,
		InvalidReservationModal,
		EventWelcomeOverlay,
		FooterWelcom,
	},
	inject: {
		userRepository: 'userRepository',
		allergenRepository: 'allergenRepository',
		reservationRepository: 'reservationRepository',
		manageToken: 'manageToken',
	},
	data() {
		return {
			webSocketClient: WebSocketClient,
			isCreator: false,
			isCannotBeReserved: null,
			saveAllergensButtonContent: 'Guardar',
			contactMessage: "",
			allergens: null,
			phoneInputFirst: null,
			textTitle: ''
		};
	},

	beforeMount() {
		this.webSocketClient = new WebSocketClient(this, this.websocketUrl, this.websocketPort);
		this.webSocketClient.connect(this.user.hostCode);

		if (this.user) {
			console.log('SOY CREADOR')
			this.textTitle = '¡Hola'
		} else {
			console.log('SOY INVITADO')
			this.textTitle = 'Asistencia confirmada'
		}

	},
	async mounted() {
		if (this.actionParam) {
			console.log('EL ACTION PARAMM!!!');
			let modal = null;
			switch (this.actionParam) {
				case '1': {
					if (this.userReservations.find(reservation => reservation.id === this.reservationIdParam)) {
						modal = document.getElementById('modalCancelReserve-' + this.reservationIdParam);
					} else {
						modal = document.getElementById('modalInvalidCancelReserve');
					}

					break;
				}
				case '2': {
					modal = document.getElementById('modalUpdateReserve-' + this.reservationIdParam)
				}

			}

			if (modal) {
				let bootstrapModal = new bootstrap.Modal(modal);
				bootstrapModal.show();
			}
		}

		// Handle event confirmation status from query params
		if (this.eventConfirmationStatus) {
			this.$nextTick(() => {
				this.showEventConfirmationToast(this.eventConfirmationStatus);
			});
		}

		this.removeQueryParams();
	},
	computed: {
		...mapState('user', ['user', 'userReservations']),
		...mapGetters('user', ['latestVenueConfig']),
		...mapGetters('config', ['websocketUrl', 'websocketPort', 'weWelcomUrl']),
		...mapGetters('wePass', ['actionParam', 'reservationIdParam', 'eventConfirmationStatus']),
	},
	methods: {
		showToast(toastId) {
			const toastElement = document.getElementById(toastId);
			const toastInstance = bootstrap.Toast.getOrCreateInstance(toastElement);
			toastInstance.show();
		},

		async handleSaveAllergens() {
			this.saveAllergensButtonContent = "Guardando <i class=\"fa fa-spinner fa-spin\"></i>";
			const result = await this.userRepository.updateAllergens(this.user.id, Array.from(this.user.allergens));
			if (result.result === 0) {
				this.showToast('allergiesSavedCorrectly');
				this.saveAllergensButtonContent = "Guardar";
			}
		},

		changeStatusAllergen(allergenId) {
			this.user.allergens.includes(allergenId) ?
				this.user.allergens = this.user.allergens.filter(item => item !== allergenId) :
				this.user.allergens.push(allergenId)
		},

		async sendComment() {
			const responseComment = await this.userRepository.sendComment(this.user.id, this.contactMessage);

			if (responseComment.result === 0) {
				alert('Comentario enviado con exito');
				this.contactMessage = "";
			} else {
				alert('Ha ocurrido un error');
			}
		},

		removeQueryParams() {
			let url = window.location.href;
			const urlParts = url.split('?');

			if (urlParts.length >= 2) {
				url = urlParts[0];
				window.history.replaceState({}, document.title, url);
			}
		},

		showEventConfirmationToast(status) {
			const toastEl = document.getElementById('eventConfirmationToast');
			if (!toastEl) return;

			const toastBody = toastEl.querySelector('.toast-body');
			const toastHeader = toastEl.querySelector('.toast-header strong');
			
			// Set message based on status
			let message = '';
			let title = '';
			let bgClass = 'bg-success';
			
			switch (status) {
				case 'confirmed':
					title = '¡Confirmación exitosa!';
					message = 'Tu asistencia al evento ha sido confirmada correctamente. ¡Te esperamos!';
					bgClass = 'bg-success';
					break;
				case 'already_confirmed':
					title = 'Ya confirmado';
					message = 'Tu asistencia ya había sido confirmada anteriormente.';
					bgClass = 'bg-info';
					break;
				case 'already_attended':
					title = 'Ya asististe';
					message = 'Ya has registrado tu asistencia a este evento.';
					bgClass = 'bg-info';
					break;
				default:
					return;
			}
			
			if (toastHeader) toastHeader.textContent = title;
			if (toastBody) toastBody.textContent = message;
			
			// Update toast background color
			toastEl.className = `toast align-items-center text-white border-0 ${bgClass}`;
			
			const toast = bootstrap.Toast.getOrCreateInstance(toastEl, { delay: 5000 });
			toast.show();
		},
	}
}
</script>

